import { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import { Fade } from 'react-awesome-reveal';
import clsx from 'clsx';

// Imports => Constants
import {
  DATETIME_FORMATS,
} from '@opp/ui-kit';

// Imports => Utilities
import {
  AcIsSet,
  AcCapitalize,
} from '@opp/ui-kit';
import { AcFormatDate } from '@utils';

// Imports => Atoms
import {
  AcCard,
  AcHeading,
  AcRichContent,
} from '@opp/ui-kit';
import {withTranslation} from "react-i18next";

const _CLASSES = {
  MAIN: 'ac-changelog-list-item',
  HEADER: 'ac-changelog-list-item__header',
  FOOTER: 'ac-changelog-list-item__footer',
  TITLE: 'ac-changelog-list-item__title',
  DATETIME: 'ac-changelog-list-item__datetime',
};

/*
created: 1548854104
object: "status"
status: "expired"
uid: "sta_298db0521c77"
updated: 1548854104
*/

const AcChangelogListItem = ({ data = {}, className, i18n, t }) => {
  const getDatetimeClassNames = useMemo(() => {
    return clsx(_CLASSES.DATETIME);
  }, []);

  const getTitleClassNames = useMemo(() => {
    return clsx(_CLASSES.TITLE);
  }, []);

  const getFooterClassNames = useMemo(() => {
    return clsx(_CLASSES.FOOTER);
  }, []);

  const getHeaderClassNames = useMemo(() => {
    return clsx(_CLASSES.HEADER);
  }, []);

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN, className);
  }, [className]);

  const getID = useMemo(() => {
    return data && data.uid;
  }, [data]);

  const getUpdatedDateFormatted = useMemo(() => {
    if (!AcIsSet(data) || !AcIsSet(data.updated)) return null;

    const date_format =
            window.outerWidth <= 768
              ? DATETIME_FORMATS.FULL_DAY_WITH_YEAR_AND_TIME_SHORT
              : DATETIME_FORMATS.FULL_DAY_WITH_YEAR_AND_TIME_INCL_SECONDS;

    const updated = data.updated * 1000;
    const result = AcFormatDate(
      updated,
      null,
      date_format
    );

    return <AcRichContent className={getDatetimeClassNames} content={result} />;
  }, [data, i18n.resolvedLanguage]);

  const getTitleFormatted = useMemo(() => {
    let result = '';
    let field = '';
    let status = '';

    if(data.object === 'status') {
      field = t('changelog.field.status', 'Status', {ns: 'transactions'});
      status = t('status.' + data.status, 'Status', {ns: 'transactions'});
    }
    else {
      console.log('Missing translation for changelog.field.' + data.object);
      field = AcCapitalize(data.object);
      status = data.status
    }
    result = `${field} ${t('changelog.changed-to', 'changed to', {ns: 'transactions'})} "<strong>${status}</strong>"`;

    return (
      <AcHeading rank={6} className={getTitleClassNames}>
        {result}
      </AcHeading>
    );
  }, [data]);

  return (
    <Fade direction={'up'} duration={300} triggerOnce>
      <AcCard className={getMainClassNames} id={getID}>
        <div className={getHeaderClassNames}>{getTitleFormatted}</div>
        <div className={getFooterClassNames}>{getUpdatedDateFormatted}</div>
      </AcCard>
    </Fade>
  );
};

AcChangelogListItem.propTypes = {
  /**
     * For CSS customization
     */
  className: PropTypes.string,
};

export default withTranslation(['transactions'])(memo(AcChangelogListItem));
